<button type="button" class="dm-tooltip-inner--btn" [title]="showSpinning ? loadingText : '' " (click)="onLoad()"
    *ngIf="enableRefresh">
    <span [class]="showSpinning ? 'glyphicon glyphicon-refresh glyphicon-spin' : 'glyphicon glyphicon-refresh'"></span>
</button>
<span class="dm-tooltip-inner--btn" *ngIf="!enableRefresh" [title]="showSpinning ? loadingText : '' ">
    <span [class]="showSpinning ? 'glyphicon glyphicon-refresh glyphicon-spin' : 'glyphicon glyphicon-refresh'"></span>
</span>